module.exports = __webpack_public_path__ + "img/f-album-green.6bd8cb07.svg";